/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-20 15:14:05
 * @LastEditors: linxi
 * @LastEditTime: 2021-07-08 17:21:28
 */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import { api,sendAsync } from "../../app/applicationSlice";
import { RootState, RootThunk, RootThunkApi } from "../../app/store";
import { fromJson } from "../../models/user";
import { ExportExcelParams, getExportExcel, stordetailBody, storedetailRemove, storedetailSave } from "../../services/storedetail";
import { getUserList, GetUserListParams, getUsersInDepartment } from "../..//services/user";
import { detailPutstorage } from "../putstorage/putstorageSlice";
const initialState = {
    PutstoreDate: [],
    SelectId: 0,
    UserData: [],
    ListCurrent: 1,
    ListTotal: 0
}
export const putstoreSlice = createSlice({
    name: 'putstore',
    initialState,
    reducers: {
        setDurgData(state, action) {
            state.PutstoreDate = action.payload
        },
        setListCurrent(state, action) {
            state.ListCurrent = action.payload
        },
        setlistTotal(state, action) {
            state.ListTotal = action.payload
        },
        setSelectId(state, action) {
            state.SelectId = action.payload
        },
        setUserData(state, action) {
            state.UserData = action.payload
        },
        addRow(state, action) {
            state.PutstoreDate = action.payload
        },
        deleteRow(state, action) {
            state.PutstoreDate = action.payload
        },
        changeRow(state, action) {
            state.PutstoreDate = action.payload
        }
    }
})

export const { setDurgData, setListCurrent, setlistTotal, setSelectId, setUserData, addRow, deleteRow, changeRow } = putstoreSlice.actions

//新增
export const saveStoreDetailAsync = createAsyncThunk<
    void, stordetailBody, RootThunkApi<void>
>("Putstorage/savelist", async (body, api) => {
    return sendAsync(storedetailSave(body), api, true)
})

//业务人员
export function getUserName(
    departmentId: string
): RootThunk {
    return api(
        getUsersInDepartment(departmentId, undefined), (data: any, dispatch) => {
            const users = _.chain(data.records)
                .map((u) => fromJson(u))
                .value();
            dispatch(setUserData(users));
        }
    )
}

export function getAllUserName(params: GetUserListParams): RootThunk {
    return api(
        getUserList(params), (data: any, dispatch) => {
            const users = _.chain(data.records)
                .map((u) => fromJson(u))
                .value();
            dispatch(setUserData(users));
        }
    )
}

//删除
export function Removestoredetail(
    id: string,
    detailId?: number
): RootThunk {
    return api(
        storedetailRemove(id), (data, dispatch) => {
            dispatch(detailPutstorage(detailId as number))
        }
    )
}


// 导出
export const getExportExcelAsync = createAsyncThunk<
  void,
  any,
  RootThunkApi
>("/commodity/exportExcel", async (body, api) => {
  return sendAsync(getExportExcel(body), api);
});

export const RemovestoredetailAsync = createAsyncThunk<
    void, string, RootThunkApi<void>
>("Putstorage/removelist", async (id, api) => {
    return sendAsync(storedetailRemove(id), api, true)
})

export function getDepartment(
    params: GetUserListParams
): RootThunk {
    return api(
        getUserList(params), (data: any, dispatch) => {
            const users = _.chain(data.records)
                .map((u) => fromJson(u))
                .value();
            dispatch(setUserData(users));
        }
    )
}

export const selectorPutstoreData = (state: RootState) => state.putstore.PutstoreDate

export const selectstoreId = (state: RootState) => state.putstore.SelectId

export const sleectUserData = (state: RootState) => state.putstore.UserData

export default putstoreSlice.reducer
